
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'lib-transmission-courrier-dialog',
    imports: [OuiDialogModule, OuiIconModule, OuiButtonModule],
    templateUrl: './transmission-courrier-dialog.component.html',
    styleUrls: ['./transmission-courrier-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransmissionCourrierDialogComponent { }
